// Pour ajouter un élément à la roadmap :
// 1. Ajoutez deux entrées pour le titre et le contenu dans i18n (roadmap.items.nom-de-l-item).
// 2. Ajoutez le nom de l'entrée dans `items`.
// 3. Au besoin, ajoutez une image dans le dossier `/roadmap/preview/nom-de-l-item` (format PNG) et son nom dans itemsWithImage.
import i18next from 'i18next';

export const roadmapItemsUtils = (lang) => {

  // Changer l'ordre des items ici pour mettre à jour la roadmap
  const items = {
    accomplished: [
      "ratingScoreEcovadis",
      "integrateNewDataSources",
      "aprovallCheck",
      "integratePressVigilance",
      "thirdPartyManagement",
      "aiEnhancesEvaluations",
      "rseEvaluations",
      "aprovallPortal",
      "CreditSafe",
    ],
    inDevelopment: [
      "supplyChainDiscovery",
      "newThirdparySheet",
      "integrateCyberRisk",
      "evaluateSupplyChain",
      "mobileApplicationImprovement",
      "actionPlans",
      "thirdpartyEvent",
      "translatedForm",
      //"sisIdMonitoring",
      "filtersImprovement",
    ],
    planned: [
      "integratedDashboards",
      "AIAutoCompletion",
      "extendFormCondition",
      "CompletenessQuestionnairesAI",
      "ThirdPartyPortfolio",
      "notificationsCenter",
      "DoubleSignature",
      "PersonalizedStatuses",
      "NewSmartFlowAction",
      "ActionPlans",
      "OptimizationOfThirdparty",
      "SavingFilters",
      "InternalMessaging",
    ],
  }

  const itemsWithImage = [
    "integrateCyberRisk",
    "integratePressVigilance",
    "ratingScoreEcovadis",
    "aprovallCheck",
    "evaluateSupplyChain",
    "aprovallPortal",
    "CreditSafe",
  ]

  return Object.entries(items).reduce((acc, [key, values]) => {
    acc[key] = values.map(value => ({
      title: i18next.t(`roadmap.items.${value}.title`),
      content: i18next.t(`roadmap.items.${value}.content`),
      imageURI: itemsWithImage.includes(value) ? `/img/icons/roadmap/preview/${value}.png` : null,
      value: value
    }));
    return acc;
  }, {});

}

export const roadmapTabs = [
  {
    id: "accomplished",
    index: 0,
    label: `roadmap.category.accomplished`,
  },
  {
    id: "inDevelopment",
    index: 1,
    label: `roadmap.category.inDevelopment`,
  },
  {
    id: "planned",
    index: 2,
    label: `roadmap.category.planned`,
  },
]
